export default function Configure($stateProvider) {
    $stateProvider.state('series-tamis', {
        parent: 'common',
        url: '/series-tamis',
        //abstract: true,
        views: {
            common: {
                template: '<ui-view></ui-view>'
            }
        },
        ncyBreadcrumb: {
            //skip: true
            label: '{{ "LAYOUT.NAVIGATION.DONNEES_PARAMETRES" | translate }}'
        }
    });

    $stateProvider.state('series-tamis.list', {
        url: '/list',
        template: '<series-tamis></series-tamis>',
        rights: { domain: 'seriedim', right: 'read', application: 'gestion' },
        ncyBreadcrumb: {
            label: '{{ "SERIES_TAMIS.BREADCRUMBS.SERIES_TAMIS_LIST" | translate}}'
        },
        navigation: {
            menu: 'donnees_parametres_parametres',
            translate: 'SERIES_TAMIS.BREADCRUMBS.SERIES_TAMIS_LIST',
            order: 60,
            navigationCls: 'menu-item-separator'
        },
        search: 'RAPPORTSITM.BREADCRUMBS.SERIES_TAMIS_LIST'
    });

    $stateProvider.state('series-tamis.list.detail', {
        url: '/{id}',
        template: '<serie-tamis-detail></serie-tamis-detail>',
        rights: { domain: 'seriedim', right: 'read' },
        ncyBreadcrumb: {
            parent: 'series-tamis.list',
            label: '{{ "SERIES_TAMIS.BREADCRUMBS.SERIE_TAMIS_DETAIL" | translate}}'
        }
    });

    $stateProvider.state('series-tamis.new', {
        url: '/new',
        template: '<serie-tamis-form></serie-tamis-form>',
        rights: { domain: 'seriedim', right: 'create' },
        ncyBreadcrumb: {
            parent: 'series-tamis.list',
            label: '{{ "SERIES_TAMIS.BREADCRUMBS.SERIE_TAMIS_NEW" | translate}}'
        },
        search: 'SERIES_TAMIS.BREADCRUMBS.SERIE_TAMIS_NEW'
    });

    $stateProvider.state('series-tamis.edit', {
        url: '/{id}/edit',
        template: '<serie-tamis-form></serie-tamis-form>',
        rights: { domain: 'seriedim', right: 'update' },
        ncyBreadcrumb: {
            parent: 'series-tamis.list',
            label: '{{ "SERIES_TAMIS.BREADCRUMBS.SERIE_TAMIS_EDIT" | translate }}'
        }
    });

    $stateProvider.state('series-tamis.newType', {
        url: '/new-type',
        template: '<type-form></type-form>',
        rights: { domain: 'types', right: 'create' },
        params: { parentState: 'series-tamis.new' },
        ncyBreadcrumb: {
            parent: 'series-tamis.new',
            label: '{{ "TYPES.BREADCRUMBS.TYPE_NEW" | translate}}'
        }
    });

    $stateProvider.state('series-tamis.duplicate', {
        url: '/{id}/duplicate',
        template: '<serie-tamis-form></serie-tamis-form>',
        rights: { domain: 'seriedim', right: 'create' },
        ncyBreadcrumb: {
            parent: 'series-tamis.list',
            label: '{{ "SERIES_TAMIS.BREADCRUMBS.SERIE_TAMIS_NEW" | translate}}'
        },
        params: {
            duplicate: true
        }
    });
}

Configure.$inject = ['$stateProvider'];
